import i18nEnum from '@/i18ns/vi/i18nEnum';

export default [
  {
    path: '/three-year',
    name: 'threeYearEstimate',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/estimate/threeYearEstimate/ThreeYearEstimate.vue'),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.Ward, i18nEnum.OrganizationPackCodeType.HCSN],
    },
  },
];